module.exports = __webpack_public_path__ + "img/h2.9b081d87.png";